export default __webpack_public_path__ + "static/media/redux_black.955a2335.png";